import type { ActivityModule } from '../../core/activity';
import { mountOrderingAlphabets } from './ui';
import levelsData from './levels.json';

export const orderingAlphabets: ActivityModule = {
  id: 'ordering_alphabets',
  title: 'Ordenar letras',
  description: 'Coloque as letras na ordem do alfabeto. Clique na próxima da sequência.',
  ageMin: 5,
  ageMax: 9,
  difficulty: 2,
  iconPath: 'assets/ensinosocial/ordering_alphabets/icon.svg',
  category: 'linguagem',
  totalLevels: levelsData.levels.length,
  mount: mountOrderingAlphabets,
};
